import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=4a83a6a4&scoped=true&"
import script from "./footer.vue?vue&type=script&setup=true&lang=js&"
export * from "./footer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=4a83a6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a83a6a4",
  null
  
)

export default component.exports